import { combineReducers } from '@reduxjs/toolkit';

import accountsResource from 'src/actions/accounts/accountsResource';
import agentActivityResource from 'src/actions/agent/agentActivityResource';
import agentExperienceConfigResource from 'src/actions/agentExperienceConfig/agentExperienceConfigResource';
import agentProfileResource from 'src/actions/agent/agentProfileResource';
import agentProfilesResource from 'src/actions/agent/agentProfilesResource';
import agentSkillsResource from 'src/actions/skills/agentSkillsResource';
import agentsResource from 'src/actions/agent/agentsResource';
import agentStatusReasonsResource from 'src/actions/agentStatus/agentStatusReasonsResource';
import agentStatusResource from 'src/actions/agent/agentStatusResource';
import agentUsersResource from 'src/actions/agentUsers/agentUsersResource';
import answerLanguagesResource from 'src/actions/answers/answerLanguagesResource';
import answerSearchResource from 'src/actions/answers/answerSearchResource';
import answerTitlesResource from 'src/actions/answers/answerTitlesResource';
import answerVariablesResource from 'src/actions/answers/answerVariablesResource';
import apiTokensResource from 'src/actions/integrations/apiTokensResource';
import appFeaturesResource from 'src/actions/auth/appFeaturesResource';
import appPlatformDataAttributesDefResource from 'src/actions/externalapp/appPlatformDataAttributeDefResource';
import audiencesReferences from 'src/actions/audiences/audiencesReferencesResource';
import audiencesResource from 'src/actions/audiences/audiencesResource';
import authSlice from 'src/actions/auth/authSlice';
import automationsResource from 'src/actions/automations/automationsResource';
import availableLanguagesResource from 'src/actions/answers/availableLanguagesResource';
import availableNumbersResource from 'src/actions/availableNumbers/availableNumbersResource';
import businessHours from 'src/actions/businessHours/businessHoursResource';
import businessHoursReferences from 'src/actions/businessHours/businessHoursReferencesResource';
import campaignsResource from 'src/actions/campaigns/campaignsResource';
import channelsConfigurationResource from 'src/actions/channels/channelsConfigurationResource';
import chatCampaignSettingsResource from 'src/actions/chatCampaigns/chatCampaignSettingsResource';
import chatCampaignsResource from 'src/actions/chatCampaigns/chatCampaignsResource';
import communicationQueuesResource from 'src/actions/communicationQueues/communicationQueuesResource';
import companyPhoneNumbersResource from 'src/actions/companyPhoneNumber/companyPhoneNumbersResource';
import complianceEventsResource from 'src/actions/compliance/complianceEventsResource';
import conversationWorkflow from 'src/actions/conversationWorkflow/conversationWorkflow';
import currentAnswerResource from 'src/actions/answers/currentAnswerResource';
import customAttributesResource from 'src/actions/customAttributes/customAttributesResource';
import customChannelRecipientResource from 'src/actions/channels/customChannelRecipientResource';
import customChannelResource from 'src/actions/channels/customChannelResource';
import customChannelsConfigurationResource from 'src/actions/channels/customChannelsConfigurationResource';
import customerProfileDefResource from 'src/actions/customer/customerProfileDefResource';
import dataRetentionConfigurationResource from 'src/actions/dataRetention/dataRetentionConfigResource';
import emailAddressesResource from 'src/actions/email/emailAddressesResource';
import emailDomainsResource from 'src/actions/email/emailDomainsResource';
import emailSenderNamesResource from 'src/actions/email/emailSenderNamesResource';
import endpointsResource from 'src/actions/endpoints/endpointsResource';
import helpCenterResource from 'src/actions/helpCenter/helpCenterResource';
import httpLogsResource from 'src/actions/httpLogs/httpLogsResource';
import idleTimingResource from 'src/actions/idleTiming/idleTimingResource';
import initializeSlice from 'src/actions/initialize';
import integrationsOrgConfigResource from 'src/actions/integrations/integrationsOrgConfigResource';
import integrationsResource from 'src/actions/integrations/integrationsResource';
import ivrResource from 'src/actions/ivrs/ivrResource';
import ivrSessionContentResource from 'src/actions/ivrs/ivrSessionContentResource';
import ivrSessionsResource from 'src/actions/ivrs/ivrSessionsResource';
import ivrsResource from 'src/actions/ivrs/ivrsResource';
import ivrsTreeDataResource from 'src/actions/ivrs/ivrsTreeDataResource';
import keywordGroupsResource from 'src/actions/keywordGroups/keywordGroupsResource';
import lookupDebuggerAutolinkingResource from '../integrations/lookupAdapterDebugging/lookupDebuggerAutolinkingResource';
import lookupDebuggerBasicResource from '../integrations/lookupAdapterDebugging/lookupDebuggerBasicResource';
import lookupDebuggerDetailedResource from '../integrations/lookupAdapterDebugging/lookupDebuggerDetailedResource';
import messagingResource from 'src/actions/messaging/MessagingResource';
import mobileNumberIdentificationConfigResource from 'src/actions/mobileNumberIdentification/mobileNumberIdentificationConfigResource';
import organizationResource from 'src/actions/organization/organizationResource';
import organizationsResource from 'src/actions/imitate/organizationsResource';
import organizationUsersResource from 'src/actions/imitate/organizationUsersResource';
import publicAnswersResource from 'src/actions/answers/publicAnswersResource';
import recipientCollectionsResource from 'src/actions/campaigns/recipientCollectionsResource';
import recordingsResource from 'src/actions/ivrs/recordingsResource';
import relationshipLabelsResource from 'src/actions/relationshipLabels/relationshipLabelResource';
import reportBuilderConfigResource from 'src/actions/reportBuilderConfig/reportBuilderConfigResource';
import roleFeaturesSlice from 'src/actions/auth/roleFeaturesSlice';
import rolesResource from 'src/actions/roles/rolesResource';
import routingGroupsResource from 'src/actions/routingGroups/routingGroupsResource';
import routingResource from 'src/actions/routing/routingResource';
import ruleRevision from 'src/actions/rules/ruleRevision';
import rulesResource from 'src/actions/rules/rulesResource';
import scheduledReportsResource from 'src/actions/scheduledReports/scheduledReportsResource';
import searchDropdownResource from 'src/actions/searchDropdown/searchDropdownResource';
import sidekickAdminsResource from 'src/actions/sidekick/sidekickAdminsResource';
import sidekickBTreeResourcesResource from 'src/actions/sidekick/sidekickBTreeResourcesResource';
import sidekickConfigurationResource from 'src/actions/sidekick/sidekickConfigurationResource';
import sidekickCustomerResource from 'src/actions/sidekick/sidekickCustomerResource';
import sidekickExternalActionsResource from 'src/actions/sidekick/sidekickExternalActionsResource';
import sidekickExternalAppsTemplatesResource from 'src/actions/sidekick/sidekickExternalAppsTemplatesResource';
import sidekickIntegrationsResource from 'src/actions/sidekick/sidekickIntegrationsResource';
import sidekickModuleSpecsResource from 'src/actions/sidekick/sidekickModuleSpecsResource';
import sidekickRevisionsResource from 'src/actions/sidekick/sidekickRevisionsResource';
import sidekickFastThreadsResource from '../sidekick/sidekickFastThreadsResource';
import sidekickThreadsResource from 'src/actions/sidekick/sidekickThreadsResource';
import sidekickTypeSpecsResource from 'src/actions/sidekick/sidekickTypeSpecsResource';
import skillHierarchyResource from '../skills/skillHierarchyResource';
import skillsResource from '../skills/skillsResource';
import smsConfigurationResource from 'src/actions/channels/smsConfigurationResource';
import ssoConfigResource from 'src/actions/integrations/sso/ssoConfigResource';
import systemConfigurationResource from 'src/actions/systemConfiguration/systemConfigurationResource';
import taskRouting from 'src/actions/taskRouting/taskRouting';
import teamsResource from 'src/actions/teams/teamsResource';
import temporaryAuthTokensResource from 'src/actions/temporaryAuthTokens/temporaryAuthTokensResource';
import threadResource from 'src/actions/threads/threadResource';
import threadsConfigurationResource from 'src/actions/threads/threadsConfigurationResource';
import threadsResource from 'src/actions/threads/threadsResource';
import threadUiSlice from 'src/presentation/components/pages/sidekick/threads/actions/threadsUiSlice';
import toastSlice from 'src/actions/toast';
import topicsHierarchyResource from 'src/actions/topics/topicsHierarchyResource';
import topicsResource from 'src/actions/topics/topicsResource';
import twitterResource from 'src/actions/endpoints/twitterResource';
import usersResource from 'src/actions/users/usersResource';
import voiceConfigResource from 'src/actions/voice/voiceConfigResource';
import voiceConfigurationResource from 'src/actions/channels/voiceConfigurationResource';
import webhooksResource from 'src/actions/integrations/webhooksResource';
import whatsAppSenderResource from 'src/actions/channels/whatsAppSenderResource';

const reducers = {
  accounts: accountsResource.reducer,
  agentActivityResource: agentActivityResource.reducer,
  agentExperienceConfig: agentExperienceConfigResource.reducer,
  agentProfile: agentProfileResource.reducer,
  agentProfiles: agentProfilesResource.reducer,
  agents: agentsResource.reducer,
  agentSkills: agentSkillsResource.reducer,
  agentStatus: agentStatusResource.reducer,
  agentStatusReasons: agentStatusReasonsResource.reducer,
  agentUsers: agentUsersResource.reducer,
  answerLanguages: answerLanguagesResource.reducer,
  answerSearch: answerSearchResource.reducer,
  answerTitles: answerTitlesResource.reducer,
  answerVariables: answerVariablesResource.reducer,
  apiTokens: apiTokensResource.reducer,
  appFeatures: appFeaturesResource.reducer,
  appPlatformDataAttributeDef: appPlatformDataAttributesDefResource.reducer,
  audiences: audiencesResource.reducer,
  audiencesReferences: audiencesReferences.reducer,
  auth: authSlice.reducer,
  automations: automationsResource.reducer,
  availableLanguages: availableLanguagesResource.reducer,
  availableNumbers: availableNumbersResource.reducer,
  businessHours: businessHours.reducer,
  businessHoursReferences: businessHoursReferences.reducer,
  campaigns: campaignsResource.reducer,
  channelsConfiguration: channelsConfigurationResource.reducer,
  chatCampaigns: chatCampaignsResource.reducer,
  chatCampaignSettings: chatCampaignSettingsResource.reducer,
  communicationQueues: communicationQueuesResource.reducer,
  companyPhoneNumbers: companyPhoneNumbersResource.reducer,
  complianceEvents: complianceEventsResource.reducer,
  conversationWorkflow: conversationWorkflow.reducer,
  currentAnswer: currentAnswerResource.reducer,
  customAttributes: customAttributesResource.reducer,
  customChannelRecipients: customChannelRecipientResource.reducer,
  customChannels: customChannelResource.reducer,
  customChannelsConfiguration: customChannelsConfigurationResource.reducer,
  customerDataRetentionConfig: dataRetentionConfigurationResource.reducer,
  customerProfileDef: customerProfileDefResource.reducer,
  debugAutolinkingLookup: lookupDebuggerAutolinkingResource.reducer,
  debugBasicLookup: lookupDebuggerBasicResource.reducer,
  debugDetailedLookup: lookupDebuggerDetailedResource.reducer,
  emailAddresses: emailAddressesResource.reducer,
  emailDomains: emailDomainsResource.reducer,
  emailSenderNames: emailSenderNamesResource.reducer,
  endpoints: endpointsResource.reducer,
  helpCenter: helpCenterResource.reducer,
  httpLogs: httpLogsResource.reducer,
  idleTiming: idleTimingResource.reducer,
  initialized: initializeSlice.reducer,
  integrations: integrationsResource.reducer,
  integrationsOrgConfig: integrationsOrgConfigResource.reducer,
  ivr: ivrResource.reducer,
  ivrs: ivrsResource.reducer,
  ivrSessionContent: ivrSessionContentResource.reducer,
  ivrSessions: ivrSessionsResource.reducer,
  ivrsTreeData: ivrsTreeDataResource.reducer,
  keywordGroups: keywordGroupsResource.reducer,
  messaging: messagingResource.reducer,
  mobileNumberIdentificationConfig: mobileNumberIdentificationConfigResource.reducer,
  organization: organizationResource.reducer,
  organizations: organizationsResource.reducer,
  organizationUsers: organizationUsersResource.reducer,
  publicAnswers: publicAnswersResource.reducer,
  recipientCollections: recipientCollectionsResource.reducer,
  recordings: recordingsResource.reducer,
  relationshipLabels: relationshipLabelsResource.reducer,
  reportBuilderConfig: reportBuilderConfigResource.reducer,
  roleFeatures: roleFeaturesSlice.reducer,
  roles: rolesResource.reducer,
  routing: routingResource.reducer,
  routingGroups: routingGroupsResource.reducer,
  ruleRevision: ruleRevision.reducer,
  rules: rulesResource.reducer,
  scheduledReports: scheduledReportsResource.reducer,
  searchDropdown: searchDropdownResource.reducer,
  sidekickAdmins: sidekickAdminsResource.reducer,
  sidekickBTreeResources: sidekickBTreeResourcesResource.reducer,
  sidekickConfiguration: sidekickConfigurationResource.reducer,
  sidekickCustomer: sidekickCustomerResource.reducer,
  sidekickExternalActions: sidekickExternalActionsResource.reducer,
  sidekickExternalAppsTemplates: sidekickExternalAppsTemplatesResource.reducer,
  sidekickIntegrations: sidekickIntegrationsResource.reducer,
  sidekickModuleSpecs: sidekickModuleSpecsResource.reducer,
  sidekickRevisions: sidekickRevisionsResource.reducer,
  sidekickThreads: sidekickThreadsResource.reducer,
  sidekickFastThreads: sidekickFastThreadsResource.reducer,
  sidekickTypeSpecs: sidekickTypeSpecsResource.reducer,
  skillHierarchy: skillHierarchyResource.reducer,
  skills: skillsResource.reducer,
  smsConfiguration: smsConfigurationResource.reducer,
  ssoConfig: ssoConfigResource.reducer,
  systemConfiguration: systemConfigurationResource.reducer,
  taskRouting: taskRouting.reducer,
  teams: teamsResource.reducer,
  temporaryAuthTokens: temporaryAuthTokensResource.reducer,
  thread: threadResource.reducer,
  threads: threadsResource.reducer,
  threadsConfiguration: threadsConfigurationResource.reducer,
  threadUi: threadUiSlice.reducer,
  toasts: toastSlice.reducer,
  topics: topicsResource.reducer,
  topicsHierarchy: topicsHierarchyResource.reducer,
  twitter: twitterResource.reducer,
  users: usersResource.reducer,
  voiceConfig: voiceConfigResource.reducer,
  voiceConfiguration: voiceConfigurationResource.reducer,
  webhooks: webhooksResource.reducer,
  whatsAppSender: whatsAppSenderResource.reducer,
};

// Each reducer has an initial state, so the rootReducer defines all of the actions
// that we can handle as well as all of the default values for each sub-tree from
// the root.
const rootReducer = combineReducers(reducers);

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
